

import { useParams } from 'react-router-dom';
import { AuthLayout } from '../../../components/AuthLayout';
import { IndividualForm } from '../../../components/IndividualForm';
import { CorporateForm } from '../../../components/CorporateForm';
import { VendorForm } from '../../../components/VendorForm';
import Logo from '../../../assets/images/logo.png';

export const SignUpPage = () => {
  const { type } = useParams();

  const renderForm = () => {
    switch (type) {
      case 'vendor':
        return <VendorForm />;
      case 'corporate':
        return <CorporateForm />;
      default:
        return <IndividualForm />;
    }
  };

  const getTitle = () => {
    if (type === 'vendor') return "Vendor";
    if (type === 'corporate') return "Corporate";
    return "Individual";
  };

  return (
    <AuthLayout directory="/role-selection" showBackLink={true}>
      <div style={{ width: '95%', backgroundColor: '#fff', margin: '40px auto', borderRadius: '20px', boxShadow: '0px 4px 24px 0px #00000040', padding: '40px 30px', textAlign: 'center', fontFamily: 'Manrope", sans-serif' }}>
        <img src={Logo} alt="Logo" style={{ width: '30%', height: 'auto'}} />
        <h1 style={{ fontSize: '24px', fontWeight: '700', margin: '40px 0px 10px', color: '#1F2933' }}>Create Your Account</h1>
        <span style={{ fontSize: '16px', color: '#4B5563' }}>Signing up as </span><span style={{ fontSize: '16px', fontWeight: '700', color: '#1F2933' }}>{getTitle()}</span>
        
        {renderForm()}
      </div>
      
    </AuthLayout>
  );
};